module.exports = "images/Business-Live0.svg";